import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Box, Typography } from "@mui/material";
import { CloseIcon } from "src/Icons";
import { CustomCardBox } from "src/styledComponents";

const getServiceLength = (category: any) => {
  const result = category?.children
    .reduce((total: any, child: any) => total + (child.services ? child.services.length : 0), 0) || 0
  return result
}


interface SimpleCategoryCardProps {
  isSelected: boolean;
  category: any;
  onClick: (category: any) => void;
}

export const SimpleCategoryCard = ({
  isSelected,
  category,
  onClick
}: SimpleCategoryCardProps ) => {

  return (
    <Box
      onClick={() => onClick(category)}
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #9C9DA0",
        borderColor: isSelected ? "#BF295C" : "#9C9DA0",
        backgroundColor: isSelected ? "#FFF8FA" : "#FFFFFF",
        borderRadius: "8px",
        padding: "6px",
        flex: "0 1 144px",
        cursor: "pointer",
        marginTop: "16px",
        height: "60px",
        "&:hover": {
          backgroundColor: "#FFF8FA",
        },
      }}
    >
      <Avatar
        variant="rounded"
        src={category?.image}
        sx={{
          width: "45px",
          height: "45px",
          borderRadius: "6px",
        }}
      >
        <PersonIcon
          sx={{
            fontSize: "32px",
          }}
        />
      </Avatar>
      <Box
        sx={{
          marginLeft: "12px",
          display: "flex",
          maxWidth: '138px',
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <Typography
          sx={{
            marginLeft: '6px',
            fontWeight: "500",
            fontSize: "14px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: 'uppercase',
          }}
        >
          {category.title}
        </Typography>
        <Typography
          sx={{
            marginLeft: '6px',
            fontWeight: "200",
            fontSize: "12px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {category?.services?.length + getServiceLength(category)} services
        </Typography>
      </Box>
      <>
        {isSelected &&
          <CloseIcon
            sx={{
              width: "20px",
              height: "20px",
              color: "#BF295C",
            }}
          />
        }
      </>
    </Box>
  );
}

interface MidCategoryCardProps {
  isSelected: boolean;
  category: any;
  onClick: (category: any) => void;
}

export const MidCategoryCard = ({
  isSelected,
  category,
  onClick
}: MidCategoryCardProps) => {

  return (
    <Box
      onClick={() => onClick(category)}
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #9C9DA0",
        borderColor: isSelected ? "#BF295C" : "#9C9DA0",
        backgroundColor: isSelected ? "#FFF8FA" : "#FFFFFF",
        borderRadius: "8px",
        padding: "6px",
        cursor: "pointer",
        margin: "0px 10px",
        height: "80px",
        width: "224px",
        "&:hover": {
          backgroundColor: "#FFF8FA",
        },
      }}
    >
      <Avatar
        variant="rounded"
        src={category?.image}
        sx={{
          width: "66px",
          height: "66px",
          borderRadius: "6px",
        }}
      >
        <PersonIcon
          sx={{
            fontSize: "62px",
          }}
        />
      </Avatar>
      <Box
        sx={{
          marginLeft: "12px",
          display: "flex",
          maxWidth: '138px',
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "14px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textTransform: 'uppercase',
          }}
        >
          {category?.title}
        </Typography>
        <Typography
          sx={{
            fontWeight: "200",
            fontSize: "12px",
            overflowWrap: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {category?.children?.length || 0 } subcategories
        </Typography>
        <Typography
          sx={{
            fontWeight: "200",
            fontSize: "12px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {category?.services?.length + getServiceLength(category)} services
        </Typography>
      </Box>
    </Box>
  );
}
